import React from "react";
import Input from "./ForewardrefButton";
import Button from "./ButtonConfiqReplace";
import { Link } from "react-router-dom";

function ForgotPassword() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">

      <div className="relative bottom-30 bg-white p-8 rounded-xl shadow-lg w-full max-w-md">

        <h2 className="text-2xl font-semibold text-center mb-6">
          Forgot Password
        </h2>

        <form className="space-y-4">

          <Input label="Email" placeholder="Enter registered email" />

          <Button className="w-full">
            Send Reset Link
          </Button>

          <p className="text-center text-sm">
            Back to <Link to="/login" className="text-blue-500">Login</Link>
          </p>

        </form>
      </div>
    </div>
  );
}

export default ForgotPassword;